import { getFeaturedContentFeed } from '@/api/feed';

export default {
  namespaced: true,
  state: {
    contentLoading: false,
    content: [],
    pagination: {
      page: 0,
      limit: 9,
      showLoadMoreButton: false,
    },
  },
  mutations: {
    setContentLoading(state, isLoading) {
      state.contentLoading = isLoading;
    },
    setContent(state, payload) {
      state.content = state.content.concat(payload);
    },
    setPagination(state, { length }) {
      const { limit } = state.pagination;
      if (length < limit) {
        state.pagination.showLoadMoreButton = false;
        return;
      }
      state.pagination.page += 1;
      state.pagination.showLoadMoreButton = true;
    },
    reset(state) {
      state.pagination.page = 0;
      state.pagination.showLoadMoreButton = false;
      state.content = [];
    },
  },
  actions: {
    loadContent: async ({ commit, getters, dispatch }) => {
      try {
        commit('setContentLoading', true);
        const { page, limit } = getters.pagination;
        const { data } = await getFeaturedContentFeed(page, limit);
        commit('setContent', data);
        commit('setPagination', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setContentLoading', false);
      }
    },
  },
  getters: {
    contentLoading: state => state.contentLoading,
    content: state => state.content,
    pagination: state => state.pagination,
  },
};
